<template>
  <!--
          作者：luoyiming
          时间：2019-10-25
          描述：会员-用户列表
      -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form
        size="small"
        :inline="true"
        :model="formInline"
        class="demo-form-inline"
      >
        <el-form-item label="关键词">
          <el-input
            v-model="formInline.nick_name"
            placeholder="请输入昵称|手机号|ID"
          ></el-input>
        </el-form-item>
        <el-form-item label="黑名单">
          <el-select v-model="formInline.isblack" placeholder="请选择">
            <el-option label="所有用户" value="0"> </el-option>
            <el-option label="黑名单" value="1"> </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="会员等级">
          <el-select v-model="formInline.grade_id" placeholder="请选择">
            <el-option label="全部" value="0"></el-option>
            <el-option v-for="(item, index) in gradeList" :key="index" :label="item.name" :value="item.grade_id">
            </el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="来源">
          <el-select v-model="formInline.reg_source" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option label="小程序" value="wx"></el-option>
            <el-option label="APP" value="app"></el-option>
            <el-option label="H5" value="h5"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="注册时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker
              v-model="formInline.reg_date"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item
          ><el-button
            size="small"
            type="primary"
            icon="el-icon-search"
            @click="onSubmit"
            >查询</el-button
          ></el-form-item
        >
        <el-form-item
          ><el-button size="small" type="success" @click="dialogVisible = true"
            >导出</el-button
          ></el-form-item
        >
      </el-form>
      <!-- <div class="mb16">
        <span>标签</span>
        <span class="pl10">
          <el-radio-group v-model="formInline.tag_id" size="mini" @change="onSubmit">
            <el-radio-button label="0">全部</el-radio-button>
            <el-radio-button :label="item.tag_id" v-for="(item, index) in allTag" :key="index">
              {{item.tag_name}}
            </el-radio-button>
          </el-radio-group>
        </span>
      </div> -->
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table
          size="small"
          :data="tableData"
          border
          style="width: 100%"
          v-loading="loading"
        >
          <el-table-column
            prop="user_id"
            label="ID"
            width="80"
          ></el-table-column>
          <el-table-column label="昵称">
            <template slot-scope="scope">
              {{ scope.row.nickName ? scope.row.nickName : "null" }}
            </template>
          </el-table-column>
          <el-table-column prop="nickName" label="头像">
            <template slot-scope="scope">
              <img
                v-if="scope.row.avatarUrl"
                :src="'https://shoujizulin2.rchz.top/' + scope.row.avatarUrl"
                width="30px"
                height="30px"
              />
            </template>
          </el-table-column>
          <!-- <el-table-column prop="gender" label="性别">
            <template slot-scope="scope">
              {{ scope.row.gender | convertSex }}
              未知
            </template>
          </el-table-column> -->
          <!-- <el-table-column prop="" label="会员等级">
            <template slot-scope="scope">
              <span v-if="scope.row.grade_id == 0">无等级</span>
              <span v-else>{{ scope.row.grade.name }}</span>
            </template>
          </el-table-column> -->
          <!-- <el-table-column prop="mobile" label="来源">
            <template slot-scope="scope">
              <span v-if="scope.row.reg_source == 'wx'">小程序</span>
              <span v-if="scope.row.reg_source == 'app'">APP</span>
              <span v-if="scope.row.reg_source == 'h5'">H5</span>
            </template>
          </el-table-column> -->
          <!-- <el-table-column prop="points" label="积分"></el-table-column> -->
          <!-- <el-table-column prop="balance" label="余额"></el-table-column> -->
          <!-- <el-table-column prop="country" label="国家">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              中国
            </template>
          </el-table-column> -->
          <!-- <el-table-column prop="province" label="省份"></el-table-column> -->
          <!-- <el-table-column prop="city" label="城市"></el-table-column> -->
          <el-table-column prop="reg_source" label="注册渠道">
            <template slot-scope="{ row }">
              {{ channelOptions.find(i => i.value === row.reg_source).label || '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="mobile" label="手机号"></el-table-column>
          <el-table-column prop="blackback" label="拉黑备注"></el-table-column>
          <el-table-column prop="blackadmin" label="操作人"></el-table-column>
          <el-table-column
            prop="create_time"
            label="注册时间"
            width="140"
          ></el-table-column>
          <el-table-column fixed="right" label="操作" width="170">
            <template slot-scope="scope">
              <el-button
                @click="editClick1(scope.row)"
                type="text"
                size="small"
                v-auth="'/user/user/recharge'"
                >编辑
              </el-button>
              <!-- <el-button @click="addClick(scope.row)" type="text" size="small" v-auth="'/user/user/recharge'">充值
              </el-button>
              <el-button @click="editClick(scope.row)" type="text" size="small" v-auth="'/user/user/grade'">等级
              </el-button>
              <el-button @click="tagClick(scope.row)" type="text" size="small" v-auth="'/user/user/delete'">标签
              </el-button> -->
              <el-button
                @click="deleteClick(scope.row)"
                type="text"
                size="small"
                v-auth="'/user/user/delete'"
                >删除
              </el-button>
              <el-button @click="viewClick(scope.row)" type="text" size="small"
                >查看
              </el-button>
              <el-button @click="Block(scope.row)" type="text" size="small"
                >拉黑
              </el-button>
              <el-button @click="restore(scope.row)" type="text" size="small"
                >恢复为白名单
              </el-button>
              <el-button
                @click="tuiguang(scope.row)"
                type="text"
                size="small"
                >查看推广
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 密码弹窗 -->
      <el-dialog title="请输入密码" :visible.sync="dialogVisible" width="20%">
        <div style="height: 100px">
          <el-input
            placeholder="请输入密码"
            v-model="sdinput"
            show-password
          ></el-input>
          <div style="margin-top: 20px; display: flex; justify-content: center">
            <el-button type="primary" @click="sdqd()">确定</el-button>
          </div>
        </div>
      </el-dialog>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="20"
          layout="total, sizes,prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <!-- 显示推广订单 -->
    <el-dialog
      title="提示"
      :visible.sync="dialogVisibleTg"
      width="50%"
    >
    <el-table
    :data="tglist"
    style="width: 100%">
    <el-table-column
      label="订单号">
      <template slot-scope="scope">
        {{scope.row.order_no}}
      </template>
    </el-table-column>

    <el-table-column
      label="总租金">
      <template slot-scope="scope">
        {{scope.row.pay_price}}
      </template>
    </el-table-column>

    <el-table-column
      label="代理商分佣比例">
      <template slot-scope="scope">
        {{ proportion_of_agents }}% 
      </template>
    </el-table-column>
  </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleTg = false">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 加入黑名单弹框 -->
    <el-dialog
      title="加入黑名单"
      :visible.sync="dialogVisibleBlack"
      width="30%"
    >
      <div class="jianju">
        <el-input placeholder="请输入内容" v-model="blackback">
          <template slot="prepend">黑名单备注</template>
        </el-input>
      </div>
      <div class="jianju">
        <el-input placeholder="请输入内容" v-model="blackadmin">
          <template slot="prepend">操作人名称</template>
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleBlack = false">取 消</el-button>
        <el-button type="primary" @click="determine()">确 定</el-button>
      </span>
    </el-dialog>

    <!--会员充值-->
    <Recharge
      v-if="open_add"
      :open_add="open_add"
      :form="userModel"
      :gradeList="gradeList"
      @closeDialog="closeDialogFunc($event, 'add')"
    ></Recharge>
    <!--会员等级-->
    <Grade
      v-if="open_edit"
      :open_edit="open_edit"
      :form="userModel"
      :gradeList="gradeList"
      @closeDialog="closeDialogFunc($event, 'edit')"
    ></Grade>
    <!--会员编辑-->
    <Useredit
      v-if="open_edit1"
      :open_edit1="open_edit1"
      :form="userModel"
      :gradeList="gradeList"
      @closeDialog="closeDialogFunc($event, 'edit1')"
    ></Useredit>
    <!--会员标签-->
    <Tag
      v-if="open_tag"
      :open_tag="open_tag"
      :form="userModel"
      @closeDialog="closeDialogFunc($event, 'tag')"
    ></Tag>
    <!--会员信息查看-->
    <UserView
      v-if="open_view"
      :open_edit1="open_view"
      :form="userModel"
      :gradeList="gradeList"
      @closeDialog="closeDialogFunc($event, 'edit2')"
    ></UserView>
  </div>
</template>

<script>
import UserApi from "@/api/user.js";
import OrderApi from "@/api/order.js";
import Grade from "./dialog/Grade.vue";
import Useredit from "./dialog/Useredit.vue";
import UserView from "./dialog/UserView.vue";
import Recharge from "./dialog/Recharge.vue";
import Tag from "./dialog/Tag.vue";
export default {
  components: {
    /*编辑组件*/
    Grade,
    Recharge,
    Tag,
    Useredit,
    UserView,
  },
  data() {
    return {
      proportion_of_agents:"",
      tglist:"",
      dialogVisibleTg:false,
      user_id: "", // userid
      blackback: "",
      blackadmin: "",
      dialogVisibleBlack: false, // 黑名单弹框显示
      sdinput: "",
      dialogVisible: false,
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
        nick_name: "",
        grade_id: "",
        reg_date: "",
        tag_id: 0,
        reg_source: "",
        isblack: "",
      },
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      open_edit1: false,
      open_view: false,
      /*当前编辑的对象*/
      userModel: {},
      /*等级*/
      gradeList: [],
      open_tag: false,
      /*所有标签*/
      allTag: [],
      channelOptions: [
        { label: 'H5', value: '6' },
        { label: '抖音', value: 'dy' },
        { label: '微信', value: 'wx' },
        { label: '支付宝', value: '7' },
      ],
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    // 查看推广
    tuiguang(id) {
      let self = this;
      console.log(id.proportion_of_agents);
      self.proportion_of_agents = id.proportion_of_agents;
      let user_id = id.user_id;
      UserApi.check(
        {
          user_id,
        },
        true
      ).then((data) => {
        console.log(data, "成功");
        self.tglist = data.data;
        self.dialogVisibleTg = true;
        self.$message({
          type: "success",
          message: "获取成功",
        });
      });
    },
    //恢复
    restore(val) {
      let self = this;
      self.user_id = val.user_id;
      self
        .$confirm("是否要将该用户恢复为白名单?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          UserApi.edituser(
            {
              user_id: self.user_id,
              isblack: 0,
            },
            true
          ).then((data) => {
            console.log(data, "成功");
            self.tglist = data.data;
            self.dialogVisibleBlack = false;
            self.getTableList();
            self.$message({
              type: "success",
              message: "操作成功",
            });
          });
        })
        .catch(() => {
          self.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 拉黑
    Block(val) {
      console.log(val);
      this.user_id = val.user_id;
      this.dialogVisibleBlack = true;
    },
    // 拉黑确定
    determine() {
      let self = this;
      console.log(self.blackback, self.blackadmin);
      if (self.blackback == "") {
        self.$message({
          type: "error",
          message: "请填写备注",
        });
        return;
      }
      if (self.blackadmin == "") {
        self.$message({
          type: "error",
          message: "请填写操作人",
        });
        return;
      }
      UserApi.edituser(
        {
          user_id: self.user_id,
          blackback: self.blackback,
          blackadmin: self.blackadmin,
          isblack: 1,
        },
        true
      ).then((data) => {
        console.log(data, "成功");
        self.dialogVisibleBlack = false;
        self.getTableList();
        self.$message({
          type: "success",
          message: "操作成功",
        });
      });
    },
    sdqd() {
      OrderApi.checkpwd(
        {
          password: this.sdinput,
        },
        true
      ).then((data) => {
        console.log(data, "成功");
        if (data.msg == "操作成功") {
          this.dialogVisible = false;
          this.$message({
            type: "success",
            message: "操作成功",
          });
          this.onExport();
        } else {
          this.$message.error("操作失败");
        }
      });
    },
    onExport() {
      let baseUrl = window.location.protocol + "//" + window.location.host;
      window.location.href = baseUrl + "/index.php/shop/user.user/export";
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = self.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      UserApi.userlist(Params, true)
        .then((data) => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
          self.gradeList = data.data.grade;
          self.allTag = data.data.allTag;
        })
        .catch((error) => {
          self.loading = false;
        });
    },

    /*搜索查询*/
    onSubmit() {
      let self = this;
      self.loading = true;
      let Params = self.formInline;
      self.getTableList();
    },

    /*打开添加*/
    addClick(item) {
      this.userModel = item;
      this.open_add = true;
    },

    /*打开编辑*/
    editClick(item) {
      this.userModel = item;
      this.open_edit = true;
    },

    /*编辑用户*/
    editClick1(item) {
      this.userModel = item;
      this.open_edit1 = true;
    },

    viewClick(item) {
      this.userModel = item;
      this.open_view = true;
    },

    tagClick(item) {
      this.userModel = item;
      this.open_tag = true;
    },

    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == "add") {
        this.open_add = e.openDialog;
        if (e.type == "success") {
          this.getTableList();
        }
      }
      if (f == "edit") {
        this.open_edit = e.openDialog;
        if (e.type == "success") {
          this.getTableList();
        }
      }
      if (f == "edit1") {
        this.open_edit1 = e.openDialog;
        if (e.type == "success") {
          this.getTableList();
        }
      }
      if (f == "tag") {
        this.open_tag = e.openDialog;
        if (e.type == "success") {
          this.getTableList();
        }
      }
      if (f == "edit2") {
        this.open_view = e.openDialog;
        if (e.type == "success") {
          this.getTableList();
        }
      }
    },

    /*删除用户*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          self.loading = true;
          UserApi.deleteuser(
            {
              user_id: row.user_id,
            },
            true
          )
            .then((data) => {
              self.loading = false;
              if (data.code == 1) {
                self.$message({
                  message: "恭喜你，用户删除成功",
                  type: "success",
                });
                self.getTableList();
              } else {
                self.loading = false;
              }
            })
            .catch((error) => {
              self.loading = false;
            });
        })
        .catch(() => {
          self.loading = false;
        });
    },
  },
};
</script>
<style>
.jianju {
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/views/user/user/index.vue